var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 317.517,
    height: 318.308,
    viewBox: "0 0 317.517 318.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 222.45,
    height: 228.864,
    fill: "#036"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 142.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M169.3,311.212c.112,3.042-3.823,5.772-6.359,4.214-5.182-3.184-10.328-6.449-15.323-9.923q-48.61-33.8-97.16-67.7c-5.182-3.6-10.566-6.91-15.832-10.393-2.067-1.366-4.137-2.746-6.075-4.289-1.511-1.2-3.814-2.65-2.063-4.838a4.814,4.814,0,0,1,6.091-1.5c1.773.95,3.306,2.349,5,3.463,34.484,22.672,68.376,46.225,102.072,70.072,8.655,6.125,17.333,12.211,26.38,17.742,1.286.786,2.966,1.271,3.268,3.148",
    transform: "translate(-13.423 -111.014)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M115.03,151.5c1.457-.238,3.165.841,4.854,2.023a157.181,157.181,0,0,1,15.128,12.542c21.651,19.593,41.674,40.891,62.694,61.143,9.451,9.105,19.074,18.027,28.594,27.059,1.6,1.52,3.578,2.848,1.2,5.542-2.737,3.1-3.317,3.42-6.336.534-15.7-15.005-31.849-29.548-46.956-45.18-15.266-15.8-30.993-31.1-47.015-46.1-3.791-3.549-7.9-6.749-11.888-10.085-1.038-.869-2.172-1.618-3.228-2.467a3.158,3.158,0,0,1-1.21-3.621c.575-1.67,2.167-1.152,4.158-1.386",
    transform: "translate(-57.465 -77.76)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M275.23,180.649a4.412,4.412,0,0,1-2.245,2.548,1.629,1.629,0,0,1-2.359-.375c-1.026-1.2-2.012-2.44-3-3.673-28.636-35.645-56.482-71.942-86.18-106.708-6.6-7.73-11.914-16.6-19.941-23.078a2.371,2.371,0,0,1-.878-1.01c-.535-2.022-3.025-4.154-.687-6.094,1.827-1.516,3.8,0,5.4,1.361a69.93,69.93,0,0,1,8.461,8.792c33.6,40.389,65.412,82.237,98.185,123.3,1.241,1.554,2.83,2.917,3.244,4.935",
    transform: "translate(-82.517 -21.372)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M323.034,53.8c1.43-.022,1.815,1.743,2.589,3.041,5.451,9.148,11.042,18.215,16.293,27.479q21.292,37.559,42.345,75.257c.776,1.382,1.507,2.791,2.219,4.208,2.114,4.209,1.608,5.42-2.547,6.882-1.547.545-2.579.3-3.356-1.134-.648-1.2-1.311-2.382-1.968-3.573-18.828-34.138-37.793-68.2-57.459-101.851-.8-1.369-1.7-2.691-2.369-4.124-1.383-2.961.412-5.912,4.252-6.186",
    transform: "translate(-165.249 -27.622)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M148.509,387.8a18.542,18.542,0,0,1,2.548,1.726c4.384,4.047,9.693,6.51,14.968,9.021,16.016,7.625,31.955,15.424,48.714,21.329,4.148,1.462,4.306,2.706,2.244,6.457-1.28,2.329-2.831,1.65-4.523,1-6.071-2.344-12.255-4.436-18.172-7.13-12.465-5.673-24.8-11.633-37.162-17.548a42.083,42.083,0,0,1-11.142-7.535,3.79,3.79,0,0,1-.9-4.905,4.209,4.209,0,0,1,3.421-2.412",
    transform: "translate(-75.041 -199.095)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M13.468,329.455c-4.78-.111-8.352-3.075-12.131-5.439-.758-.475-1.081-1.979-1.24-3.063-.795-5.424,3.421-11.659,9.1-13.628,6.177-2.142,12.612-.2,15.384,4.922,4.527,8.363.241,15.527-11.111,17.208M18.2,318.746c.027-2.382-1.629-4.29-4.507-5.17-1.588-.485-3.084-.636-4.125,1.092a3.838,3.838,0,0,0,0,4.449,7.273,7.273,0,0,0,3.733,2.746c3.1,1.184,4.859.079,4.9-3.117",
    transform: "translate(0 -157.336)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M95.091,357.789c.051,3.884-1.586,5.382-3.843,6.157-3.435,1.178-9.085-3.448-8.8-7.111a3.513,3.513,0,0,1,.513-1.934c1.594-1.812,3.74-1.627,5.583-.776,2.48,1.144,5.41,1.85,6.551,3.664",
    transform: "translate(-42.794 -181.484)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M295.869,4.1c.036,2.531-4.494,6.7-7.006,6.709-1.782,0-3.8-2.691-3.706-4.955.116-2.872,3.432-5.89,6.442-5.855,2.83.034,3.762,1.983,4.27,4.1",
    transform: "translate(-148.032 0)",
    fill: "#036"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpray);
export default __webpack_public_path__ + "static/media/spray.c4445abb9be35a13adafa91bdfcaa7e2.svg";
export { ForwardRef as ReactComponent };